export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Ich habe mich aktiv in die Summer School eingebracht.",
			},
			{
				id: 2,
				text: "Ich habe mich um eine gute Arbeitsatmosphäre mit den anderen Teilnehmenden bemüht.",
			},
			{
				id: 3,
				text: "Ich habe mich bereits vorab auf die Summer School vorbereitet.",
			},
			{
				id: 4,
				text: "Die Betreuung in der Summer School war professionell.",
			},
			{
				id: 5,
				text: "Die organisatorischen Rahmenbedingungen der Summer School waren angemessen.",
			},
			{
				id: 6,
				text: "Es wurden passende Hilfsmittel und Medien zur Vermittlung der Inhalte eingesetzt.",
			},
			{
				id: 7,
				text: "Die bei dem Kick-Off-Termin anvisierten Ziele wurden gut in der Summer School abgedeckt.",
			},
			{
				id: 8,
				text: "Durch die Summer School konnte ein Einblick in den Berufsalltag als Lehrperson gegeben werden.",
			},
			{
				id: 9,
				text: "Durch die Summer School habe ich mich mit meiner beruflichen Perspektive auseinandergesetzt.",
			},
			{
				id: 10,
				text: "Insgesamt fand ich die Summer School gut.",
			},
			{
				id: 11,
				text: "In der Summer School habe ich viel gelernt.",
			},
			{
				id: 12,
				text: "Meine Erwartungen an die Summer School wurden erfüllt.",
			},
			{
				id: 13,
				text: "Ich würde die Summer School weiterempfehlen.",
			},
		],
	},
	{
		type: "uni",
		id: 2,
		title: "Evaluation der Keynotes",
		items: [
			{
				id: 14,
				text: "Die Themen sind für meine Entwicklung als Lehrperson relevant.",
			},
			{
				id: 15,
				text: "Ich habe das Gefühl, wichtige Impulse erhalten zu haben.",
			},
			{
				id: 16,
				text: "Ich habe Ideen wie ich die Themen auf die Praxis transferieren kann.",
			},
		],
	},
	{
		type: "special",
		id: 3,
		items: [
			{
				id: 17,
				text: "Insgesamt bewerte ich die Keynotes mit der Note",
				label: [
					{
						id: 1,
						text: "sehr gut",
					},
					{
						id: 2,
						text: "gut",
					},
					{
						id: 3,
						text: "befriedigend",
					},
					{
						id: 4,
						text: "ausreichend",
					},
					{
						id: 5,
						text: "mangelhaft",
					},
				],
			},
		],
	},
	{
		type: "uni",
		id: 4,
		title: "Evaluation der Praxisworkshops",
		items: [
			{
				id: 18,
				text: "Die Themen sind für meine Entwicklung als Lehrperson relevant.",
			},
			{
				id: 19,
				text: "Ich habe das Gefühl, wichtige Impulse erhalten zu haben.",
			},
			{
				id: 20,
				text: "Ich habe Ideen wie ich die Themen auf die Praxis transferieren kann.",
			},
		],
	},
	{
		type: "special",
		id: 5,
		items: [
			{
				id: 21,
				text: "Insgesamt bewerte ich die Praxisworkshops mit der Note",
				label: [
					{
						id: 1,
						text: "sehr gut",
					},
					{
						id: 2,
						text: "gut",
					},
					{
						id: 3,
						text: "befriedigend",
					},
					{
						id: 4,
						text: "ausreichend",
					},
					{
						id: 5,
						text: "mangelhaft",
					},
				],
			},
		],
	},
	{
		type: "uni",
		id: 6,
		title: "Evaluation der Nähkästchen",
		items: [
			{
				id: 22,
				text: "Die Themen sind für meine Entwicklung als Lehrperson relevant.",
			},
			{
				id: 23,
				text: "Ich habe das Gefühl, wichtige Impulse erhalten zu haben.",
			},
			{
				id: 24,
				text: "Ich habe Ideen wie ich die Themen auf die Praxis transferieren kann.",
			},
		],
	},
	{
		type: "special",
		id: 7,
		items: [
			{
				id: 25,
				text: "Insgesamt bewerte ich die Nähkästchen mit der Note",
				label: [
					{
						id: 1,
						text: "sehr gut",
					},
					{
						id: 2,
						text: "gut",
					},
					{
						id: 3,
						text: "befriedigend",
					},
					{
						id: 4,
						text: "ausreichend",
					},
					{
						id: 5,
						text: "mangelhaft",
					},
				],
			},
		],
	},
	{
		type: "uni",
		id: 8,
		title: "Evaluation der Schlaglichter",
		items: [
			{
				id: 26,
				text: "Die Themen sind für meine Entwicklung als Lehrperson relevant.",
			},
			{
				id: 27,
				text: "Ich habe das Gefühl, wichtige Impulse erhalten zu haben.",
			},
			{
				id: 28,
				text: "Ich habe Ideen wie ich die Themen auf die Praxis transferieren kann.",
			},
		],
	},
	{
		type: "special",
		id: 9,
		items: [
			{
				id: 29,
				text: "Insgesamt bewerte ich die Schlaglichter mit der Note",
				label: [
					{
						id: 1,
						text: "sehr gut",
					},
					{
						id: 2,
						text: "gut",
					},
					{
						id: 3,
						text: "befriedigend",
					},
					{
						id: 4,
						text: "ausreichend",
					},
					{
						id: 5,
						text: "mangelhaft",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 10,
		items: [
			{
				id: 30,
				text: "Sonstige Anmerkungen",
			},
		],
	},
];
